import type { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { Button, Dialog, DocumentAddIcon } from "@/shared/ui";

export const MedRequestExistsAlert = ({
  ...props
}: ComponentProps<typeof Dialog.Root>) => {
  return (
    <Dialog.Root alert {...props}>
      <Dialog.Content withCloseButton={false}>
        <Dialog.Header icon={DocumentAddIcon}>
          <Dialog.Title>{t`You have a medication request in progress`}</Dialog.Title>

          <Dialog.Description>
            {t`It looks like you already have a medication request in progress. Please wait until the process is complete to book a video consultation or to order more medication. We're here to help if you need any assistance!`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button size="lg" asChild>
            <Link to={ROUTES.MY_MEDS}>{t`Review medication orders`}</Link>
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
